"use strict";

var _ContainedLayout, _span, _SupplierDashboard;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { NoResults, useContactNumbers } from '@autoguru/components';
import { ContainedLayout } from '@autoguru/layout';
import { LoadingBox, Section, Stack, Text } from '@autoguru/overdrive';
import { AsyncBoundary } from '@autoguru/suspense';
import { lazy } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SupplierDashboard = /*#__PURE__*/lazy(async () => import('./SupplierDashboard'));
const Landing = () => {
  const {
    successContactNumber
  } = useContactNumbers();
  return /*#__PURE__*/_jsx(AsyncBoundary, {
    fallback: _ContainedLayout || (_ContainedLayout = /*#__PURE__*/_jsx(ContainedLayout, {
      children: /*#__PURE__*/_jsxs(Stack, {
        space: "5",
        children: [/*#__PURE__*/_jsx(LoadingBox, {}), /*#__PURE__*/_jsx(LoadingBox, {}), /*#__PURE__*/_jsx(LoadingBox, {})]
      })
    })),
    errorFallback: /*#__PURE__*/_jsx(ContainedLayout, {
      children: /*#__PURE__*/_jsx(Section, {
        width: "small",
        children: /*#__PURE__*/_jsx(NoResults, {
          title: "Something went wrong!",
          children: /*#__PURE__*/_jsxs(Text, {
            size: "3",
            as: "p",
            align: "center",
            children: ["Sorry, your dashboard is currently not available. Please try again or call us on", _span || (_span = /*#__PURE__*/_jsx("span", {
              children: " "
            })), /*#__PURE__*/_jsx(Text, {
              size: "3",
              as: "span",
              noWrap: true,
              children: successContactNumber
            })]
          })
        })
      })
    }),
    children: _SupplierDashboard || (_SupplierDashboard = /*#__PURE__*/_jsx(SupplierDashboard, {}))
  });
};
export default Landing;